<template>
		<div>
			<div id="videoplayer" style="height:250px;width: 100%;"></div>
			<div id="video_container">
				<ctree  v-for="(item,index) in courseResourceTreeData.children" :key="index" :treelist="item" @treeTap="coursetreeplay" :treelistindex="0"></ctree>
            </div>
	</div>
</template>
<script src="//player.polyv.net/script/player.js"></script>
<script>
	import ctree from '@/components/ctree.vue';
	import { Toast } from 'vant';
	import Vue from 'vue';
	import {api_base,api_goods,api_user,api_polyv} from '@/common/Request.js';
	export default {
	data () {
	  return {
	    goodsinfo: '',
		courseId:'',
		resourceId:0,
		vplayer:'',
		courseResourceTreeData:'',
		playtimer:0
	  }
	},
	mounted(){
		if(this.$cookies.isKey("user_token"))
		{
			this.usertoken=this.$cookies.get("user_token");
			this.courseId=this.$route.query.courseId;
			this.resourceId=this.$route.query.resourceId;
			this.initData();
			
		}
	},
	methods: {
		initData(){
			api_goods.goods_detail(this.courseId).then(response => {
				this.goodsinfo = response.data;
				document.title=this.goodsinfo.name;
				this.courseResourceTreeListLoad();
			})
			
			console.log(this.resourceId);
			api_user.getPlayData(this.courseId,this.resourceId).then(res=>{
				console.log(res);
				this.videoplay(res.data)
			});
		},
		videoplay(videodata){
			console.log(videodata);
			this.vplayer=polyvPlayer({
			                  wrap: '#videoplayer',
							  width:'100%',
							  height:'100%',
			                  vid:videodata.vid,
							  // 视频播放开始时间
							  watchStartTime: videodata.currentTimes,
							  // 续播禁用
							  ban_history_time: 'on',
			                  playsafe:videodata.token,
							  viewerInfo:{
							  		viewerId:this.$cookies.get('userId'),
							  		//viewerName:this.$cookies.get('nickName'),
							  }
			                });
			this.vplayer.on('serverError', function(event, errorCode) {
			  console.log(errorCode);
		});
		// 播放器暂停
		this.vplayer.on('s2j_onVideoPause', () => {
			clearInterval(this.playtimer)
			this.playspeed()
		});
			// 播放器开始
		this.vplayer.on('s2j_onVideoPlay', () => {
			this.playtimer = setInterval(this.playspeed,10000)
		});
		// 拖拽 
		this.vplayer.on('s2j_onVideoSeek', (...params) => {
			this.playspeed1(params[1])
		});
	},
	playspeed(){
			  api_user.updateLessonStudyRate(this.courseId,this.resourceId,parseInt(this.vplayer.j2s_getCurrentTime())).then(res=>{
				console.log(res);
			  })
	},
	playspeed1(currenttimes){
			api_user.updateLessonStudyRate(this.courseId,this.resourceId,parseInt(currenttimes)).then(res=>{
				console.log(res);
			})
	},
	courseResourceTreeListLoad(){
		api_user.getCourseResourceTree(this.courseId).then(res=>{
			console.log(res);
			const treedata=res.data.root;
			this.courseResourceTreeData=treedata;
			//this.treefilter(this.courseResourceTreeData);
			console.log(this.courseResourceTreeData);
		})
	},
	treefilter(treeNodes){
		    if(!treeNodes||!treeNodes.length)return;
		    for(let i=0;i<treeNodes.length;i++){
		        let childs=treeNodes[i].children;
				if(treeNodes[i].isLeaf){
						let iconhtml="";
						if(treeNodes[i].item.resourceType==1){
							iconhtml="<i class='anticon anticon-desktop'></i> ";
							if(treeNodes[i].item.lessonStatus==3){
								treeNodes[i].item.alias=treeNodes[i].item.alias+" ("+this.formattime("YYYY-mm-dd HH:MM",new Date(treeNodes[i].item.lessonStartTime))+" 课程回放)";
							}
							else if(treeNodes[i].item.lessonStatus==0){
								treeNodes[i].item.alias=treeNodes[i].item.alias+" ("+this.formattime("YYYY-mm-dd HH:MM",new Date(treeNodes[i].item.lessonStartTime))+" 开始直播)";
							}
							else if(treeNodes[i].item.lessonStatus==1){
								treeNodes[i].item.alias=treeNodes[i].item.alias+" (直播中)";
							}
							else if(treeNodes[i].item.lessonStatus==2){
								treeNodes[i].item.alias=treeNodes[i].item.alias+" (直播完成待转码)";
							}
						}
						else if(treeNodes[i].item.resourceType==2){
							iconhtml="<i class='anticon anticon-play-circle-o'></i> ";
						}
						else if(treeNodes[i].item.resourceType==9){
							iconhtml="<i class='anticon anticon-user'></i> ";
						}
						treeNodes[i].title=iconhtml+treeNodes[i].item.alias;
				}
				else{
					treeNodes[i].title=treeNodes[i].item;
					treeNodes[i].expanded=true;
				}
		        console.log(treeNodes[i])
		        if(childs&&childs.length>0){
		            this.treefilter(childs);
		        }
		    }
	},
	coursetreeplay(data){
		console.log(data);
		console.log(this.goodsinfo);
		if(data.isLeaf){
			if(this.goodsinfo.hasBuy){
			
				if(data.item.resourceType==1){
					
					if(data.item.lessonStatus<3){
						this.$router.push({
						  path: "live_detail",
						  query: { courseId: this.courseId,
								   resourceId: data.item.resourceId
						   }
						});
					}
					else{
						this.$router.push({
						  path: "live_replay",
						  query: { courseId: this.courseId,
								   resourceId: data.item.resourceId
						   }
						});
						location.reload();
					}

					//location.reload();
				}
				else if(data.item.resourceType==2){
					console.log("playvideo")
					this.$router.push({
					  path: "course_detail",
					  query: { courseId: this.courseId,
							   resourceId: data.item.resourceId
					   }
					});
					location.reload();
				}
				else if(data.item.resourceType==9){
					Toast.fail('该课程为线下课程，请联系教务老师确定上课时间地点！');
				}
			}
			else if(data.item.trySee==1){
				if(data.item.resourceType==1){
					
					if(data.item.lessonStatus<3){
						this.$router.push({
						  path: "live_detail",
						  query: { courseId: this.courseId,
								   resourceId: data.item.resourceId
						   }
						});
					}
					else{
						this.$router.push({
						  path: "live_replay",
						  query: { courseId: this.courseId,
								   resourceId: data.item.resourceId
						   }
						});
						location.reload();
					}
				
					//location.reload();
				}
				else if(data.item.resourceType==2){
					console.log("playvideo")
					this.$router.push({
					  path: "course_detail",
					  query: { courseId: this.courseId,
							   resourceId: data.item.resourceId
					   }
					});
					location.reload();
				}
			}
			else{
				Toast.fail('请先购买课程！');
			}
		}
		
	},
	formattime(fmt, date){
			        let ret;
			        const opt = {
			            "Y+": date.getFullYear().toString(),        // 年
			            "m+": (date.getMonth() + 1).toString(),     // 月
			            "d+": date.getDate().toString(),            // 日
			            "H+": date.getHours().toString(),           // 时
			            "M+": date.getMinutes().toString(),         // 分
			            "S+": date.getSeconds().toString()          // 秒
			            // 有其他格式化字符需求可以继续添加，必须转化成字符串
			        };
			        for (let k in opt) {
			            ret = new RegExp("(" + k + ")").exec(fmt);
			            if (ret) {
			                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
			            };
			        };
			        return fmt;
	
	},

},
	components: {
	ctree
	}
}
</script>

<style scoped>
	.ant-tree{
	  padding-left: 0.5rem !important;
	}
	
	::v-deep .ant-tree li  .ant-tree-node-content-wrapper{
	  white-space: normal !important;
	  max-width: 85%;
	}
</style>
